export default __webpack_public_path__ + "static/media/somasree.328b3920.webp";